import { makeUseFetchOne } from '@elentari/core'
import { PessoasDetail } from '../types'
import { pessoasRepository } from './pessoasRepository'

export const usePessoa = makeUseFetchOne<PessoasDetail, string>({
  fetch: pessoasRepository.fetchOne
})
